import { t } from "@lingui/macro";
import * as v from "valibot";
import type { Permission } from "~/models/permission";

export const key = "collection.create";

export const permissions: Array<Permission | RegExp> = ["Collection.Create"];

export const Schema = () =>
  v.object({
    audioUids: v.optional(
      v.pipe(
        v.union([v.string(), v.array(v.string())]),
        v.transform((value) => (Array.isArray(value) ? value : [value])),
      ),
      [],
    ),
    artistUid: v.pipe(
      v.string(t`The artist ID is required.`),
      v.minLength(1, t`The artist ID is required.`),
    ),
    labelUid: v.pipe(
      v.string(t`The label ID is required.`),
      v.minLength(1, t`The label ID is required.`),
    ),
  });
